import firebase, { database } from "../firebase";
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";
import { API_URL } from "../Constatnts";







export function getRegistration(registrationID) {
  return async (dispatch, getState) => {
    let registration = null;
    // return database
    //   .collection("Registration")
    //   .doc(registrationID)
    //   .get()
    //   .then((doc) => {
    //     registration = { key: doc.id, ...doc.data() };
    //     if (!registration.hasOwnProperty("DoNotAllowPasswordChange")) {
    //       registration.DoNotAllowPasswordChange = false;
    //     }
    //     dispatch({ type: actionTypes.GET_REGISTRATION, registration });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    //9 Mar 26
    const token = getState().user.uat;
    let response = await axios.post(
      API_URL + "/getregistration",
      {
        regID: registrationID,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response && response.data && response.data.registration) {
      registration = response.data.registration;
      dispatch({ type: actionTypes.GET_REGISTRATION, registration });
    }
  };
}

function checkRegistrationInLocalStorage(registrationID) {
  let registration = JSON.parse(localStorage.getItem("registration"));
  console.log("checkRegistrationInLocalStorage", registration);
  if (registration && registration.key === registrationID) {
    return registration;
  } else {
    return null;
  }
}

function setRegistrationInLocalStorage(registration) {
  console.log("setRegistrationInLocalStorage", registration);
  localStorage.setItem("registration", JSON.stringify(registration));
}





export function updateRegistrationGeneralDetails(
  registrationID,
  generalDetails
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.put(
        `${constants.API_URL}/registration/${registrationID}`,
        generalDetails,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

    
      return true;

    } catch (error) {
      console.error("Error deleting bom:", error);
      throw error;
    }
  };
}






